export default __webpack_public_path__ + "static/oebook-hand-mobile-0767042f9812ace8751ae5a36303ef8b.png";